import { render, staticRenderFns } from "./TemplateEnvelopesCardTable.vue?vue&type=template&id=4c7f8bc4&lang=pug"
import script from "./TemplateEnvelopesCardTable.vue?vue&type=script&lang=js"
export * from "./TemplateEnvelopesCardTable.vue?vue&type=script&lang=js"
import style0 from "./TemplateEnvelopesCardTable.vue?vue&type=style&index=0&id=4c7f8bc4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports